import {useMutation} from '@apollo/client'
import React, {useEffect} from 'react'
import {Button, Form, Modal, Spinner} from 'react-bootstrap'
import {toast} from 'react-toastify'
import {parseId} from '../../../helpers'
import {ADD_EDIT_REASON} from '../../../gql/mutations/lossReasonMutaton'
import {IResAddReason} from '../../../types/reasonLoss'

interface IModalAddReasons {
  isOpen: boolean
  onClose: () => void
  refetch: () => void
  infoEdit?: null | {id: string; reason: string}
}

export const ModalAddReason: React.FC<IModalAddReasons> = ({
  isOpen,
  onClose,
  refetch,
  infoEdit,
}) => {
  const [gqlAddEditReason, {data, loading, error}] = useMutation<IResAddReason>(ADD_EDIT_REASON)

  useEffect(() => {
    if (error) toast.error('Error: ' + error.message)
  }, [error])

  useEffect(() => {
    if (!data) return
    if (data.reasonLeadLossCreateupdateMutation?.reasonLeadLoss?.id) {
      toast.success(`Success: Reason ${infoEdit ? 'edited correctly' : 'successfully added'}`)
      onClose()
      refetch()
    } else if (data.reasonLeadLossCreateupdateMutation?.errors?.length > 0) {
      toast.error(
        `Error: ${
          data.reasonLeadLossCreateupdateMutation?.errors?.[0]?.messages?.[0] ||
          'something happened'
        }`
      )
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data])

  const onSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    const {reason} = Object.fromEntries(new FormData(e.currentTarget))
    gqlAddEditReason({
      variables: {
        input: {
          id: infoEdit ? parseId(infoEdit.id) : undefined,
          reason,
        },
      },
    })
  }

  return (
    <Modal show={isOpen} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>{infoEdit ? 'Edit' : 'Add'} Reason</Modal.Title>
      </Modal.Header>
      <Form onSubmit={onSubmit}>
        <Modal.Body>
          <Form.Group className='mb-3' controlId='exampleForm.ControlInput1'>
            <Form.Label>Reason</Form.Label>
            <Form.Control
              type='text'
              name='reason'
              defaultValue={infoEdit ? infoEdit.reason : ''}
              required
              placeholder='Enter reason'
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button type='button' variant='secondary' onClick={onClose}>
            Cancel
          </Button>
          <Button
            type='submit'
            variant='primary'
            className='d-flex align-items-center'
            disabled={loading}
          >
            {loading && <Spinner animation='border' size='sm' />}
            Save Changes
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  )
}
